(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
 if (window.innerWidth >= 990) {
    document.querySelectorAll('.list-menu details').forEach(details => {
      details.addEventListener('mouseenter', () => {
        details.setAttribute('open', true);
      });
      details.addEventListener('mouseleave', () => {
        details.removeAttribute('open');
      });
      details.querySelector('summary')?.addEventListener('click', e => {
        if (window.innerWidth >= 990) {
          const link = details.querySelector('summary a');
          if (link) window.location = link.href;
          e.preventDefault();
        }
      });
    });
  }

  // ===== ADD EXTRA LOGO MENU ITEM TO BOTH DESKTOP MENU AND DRAWER MENU =====
  function placeExtraLogoMenuItem() {
    var extraLogoItem = document.querySelector('.header__extra-logo-item');
    if (!extraLogoItem) return;

    // Desktop inline / mega / dropdown menu list
    var desktopMenuList =
      document.querySelector('.header__inline-menu .list-menu--inline') ||
      document.querySelector('.header__inline-menu ul.list-menu');

    // Mobile / desktop drawer menu list (top-level <ul> only, not the nested submenus)
    var drawerMenuList = document.querySelector('.menu-drawer__navigation > ul.list-menu');

    function appendClone(menuList) {
      if (!menuList) return;
      if (menuList.querySelector('.header__extra-logo-item-wrapper')) return; // avoid duplicates

      var li = document.createElement('li');
      li.className = 'list-menu__item header__extra-logo-item-wrapper';

      var clone = extraLogoItem.cloneNode(true);
      clone.classList.add('is-placed');

      li.appendChild(clone);
      menuList.appendChild(li);
    }

    appendClone(desktopMenuList);
    appendClone(drawerMenuList);

    // Remove the original placeholder now that clones are placed
    if (extraLogoItem.parentNode) {
      extraLogoItem.parentNode.removeChild(extraLogoItem);
    }
  }

  document.addEventListener('DOMContentLoaded', placeExtraLogoMenuItem);

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
